export function isArray<T>(
  value: unknown,
  guard?: (value: unknown) => value is T
): value is T[] {
  return Array.isArray(value) && (guard ? value.every(guard) : true);
}
